export function getFilename(href: string) {
  try {
    const url = new URL(href);
    const lastSlashIndex = url.pathname.lastIndexOf('/');
    return url.pathname.slice(lastSlashIndex + 1);
  } catch (e) {
    return '';
  }
}
